import { agroApi } from "../../../../../redux/api/api";
import { MovablePropertyResponse } from "./types";

interface QueryParams {
  governmentAlias: string;
}

export const movablePropertyApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getMovableAnalyticalData: builder.query<MovablePropertyResponse, QueryParams>({
      query: (params) => ({
        url: `/register-movable-property/analytical-data?governmentAlias=${params.governmentAlias}`,
        method: 'GET'
      })
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetMovableAnalyticalDataQuery
} = movablePropertyApi;
